import { render, staticRenderFns } from "./ContactInfoModal.vue?vue&type=template&id=2160db5b&scoped=true"
import script from "./ContactInfoModal.vue?vue&type=script&lang=ts"
export * from "./ContactInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfoModal.vue?vue&type=style&index=0&id=2160db5b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2160db5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2160db5b')) {
      api.createRecord('2160db5b', component.options)
    } else {
      api.reload('2160db5b', component.options)
    }
    module.hot.accept("./ContactInfoModal.vue?vue&type=template&id=2160db5b&scoped=true", function () {
      api.rerender('2160db5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoModal.vue"
export default component.exports